export default __webpack_public_path__ + "0ecf7d8b1fb941b0bb7170818d5f8e65.png";